import React from "react";
import colors from "@streeteasy/design-system/deprecated/colors";
import { bool, string } from "prop-types";

import { AppleOutline, AppleWrapper, IconWrapper } from "./styled";

/**
 * Static AppleIcon component
 */

const AppleIcon = ({ desktopPadding, isWrapped, mobilePadding, width }) => (
  <IconWrapper desktopPadding={desktopPadding} mobilePadding={mobilePadding}>
    <AppleWrapper viewBox="0 0 31 44" width={width}>
      <AppleOutline fill="none" fillRule="evenodd" isWrapped={isWrapped}>
        <path
          d="M15.7099491,14.8846154 C16.5675461,14.8846154 17.642562,14.3048315 18.28274,13.5317864 C18.8625238,12.8312142 19.2852829,11.852829 19.2852829,10.8744437 C19.2852829,10.7415766 19.2732041,10.6087095 19.2490464,10.5 C18.2948188,10.5362365 17.1473299,11.140178 16.4588366,11.9494596 C15.9152893,12.56548 15.4200572,13.5317864 15.4200572,14.5222505 C15.4200572,14.6671964 15.4442149,14.8121424 15.4562937,14.8604577 C15.5166879,14.8725366 15.6133185,14.8846154 15.7099491,14.8846154 Z M12.6902416,29.5 C13.8618881,29.5 14.3812778,28.714876 15.8428163,28.714876 C17.3285124,28.714876 17.6546408,29.4758423 18.9591545,29.4758423 C20.2395105,29.4758423 21.0971074,28.292117 21.9063891,27.1325493 C22.8123013,25.8038779 23.1867451,24.4993643 23.2109027,24.4389701 C23.1263509,24.4148125 20.6743484,23.4122695 20.6743484,20.5979021 C20.6743484,18.1579784 22.6069612,17.0588048 22.7156707,16.974253 C21.4353147,15.1382708 19.490623,15.0899555 18.9591545,15.0899555 C17.5217737,15.0899555 16.3501271,15.9596313 15.6133185,15.9596313 C14.8161157,15.9596313 13.7652575,15.1382708 12.521138,15.1382708 C10.1536872,15.1382708 7.75,17.0950413 7.75,20.7911634 C7.75,23.0861411 8.64383344,25.513986 9.74300699,27.0842339 C10.6851558,28.4129053 11.5065162,29.5 12.6902416,29.5 Z"
          fill={colors.pureBlack}
          fillRule="nonzero"
          id=""
        />
      </AppleOutline>
    </AppleWrapper>
  </IconWrapper>
);

AppleIcon.propTypes = {
  /** A string with information about desktop padding styles */
  desktopPadding: string,
  /** Indicates if the AppleIcon should receive color behavior from a parent */
  isWrapped: bool,
  /** A string with information about padding on mobile devices. Default is null */
  mobilePadding: string,
  /** Give the icon width/height (default is 23px) */
  width: string
};

AppleIcon.defaultProps = {
  desktopPadding: "0 6px 0 0",
  isWrapped: false,
  mobilePadding: "",
  width: "23px"
};

export default AppleIcon;
